// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowRightToLine16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-right-to-line': IconArrowRightToLine;
    }
}

/**
 * The icon component for the 'arrowRightToLine' icon
 */
export class IconArrowRightToLine extends Icon {
    public constructor() {
        super(arrowRightToLine16X16);
    }
}

registerIcon('icon-arrow-right-to-line', IconArrowRightToLine);
export const iconArrowRightToLineTag = 'nimble-icon-arrow-right-to-line';
